import { ListBox } from '@vizit/atoms';
import { type ComboBoxProps, ComboBox as _Combobox } from './combobox';
import { ComboBoxEmpty } from './combobox.empty';
import { type CategoryItem, ProductCategoryLeveledItem } from './combobox.product-category-leveled-item';

const ComboBox = Object.assign(_Combobox, {
  Item: ListBox.Item,
  ProductCategoryItem: ProductCategoryLeveledItem,
  Empty: ComboBoxEmpty,
});

export type { ComboBoxProps, CategoryItem };
export { ComboBox };
